import { createSelector } from "reselect";
import getIsAndroid from "selectors/device/getIsAndroid";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";

const getVideo = (state, ownProps) =>
  state.story.entities.videos[ownProps.videoId];

export default () =>
  createSelector(
    getIsAndroid,
    getIsMobileSafari,
    getVideo,
    (isAndroid, isMobileSafari, video) =>
      isAndroid || isMobileSafari || !!video.is360,
  );
